var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  viewBox: "0 0 24 24",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.40003 19.9396C8.14003 19.9396 7.88003 19.8396 7.69003 19.6396C7.30003 19.2496 7.31003 18.6096 7.71003 18.2296L14.1 11.9796L7.66003 5.60958C7.27003 5.21958 7.26003 4.58958 7.66003 4.19958C8.05003 3.80958 8.68003 3.79958 9.07003 4.19958L16.22 11.2796C16.41 11.4696 16.52 11.7296 16.52 11.9896C16.52 12.2496 16.41 12.5096 16.22 12.6996L9.11003 19.6596C8.92003 19.8496 8.66003 19.9496 8.41003 19.9496L8.40003 19.9396Z",
  fill: "inherit"
})));
export default SvgChevronRight;